import React from "react";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import PageHeader from "Payments/PaymentPage/PageHeader";

export default function FooterLogo() {
  const {
    state: { paymentParent },
  } = usePaymentPage();
  if (!paymentParent) return null;

  return <PageHeader isFooter={true} />;
}
